import { IconProps } from "../../models/Icon";

export function FlashLightIcon({ size = 20, color = "#000", opacity = "1" }: IconProps) {
  return (
    <svg 
        width={size} 
        height={size} 
        viewBox="0 0 14 14" 
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path 
            d="M4.33416 11.4565C4.33416 11.6985 4.5283 11.894 4.76893 11.894H8.35643C8.59705 11.894 8.79119 11.6985 8.79119 11.4565V8.77686H4.33416V11.4565ZM11.5953 2.10498H1.53006C1.1951 2.10498 0.985919 2.47002 1.15408 2.76123L4.17967 7.90186H8.94842L11.974 2.76123C12.1394 2.47002 11.9303 2.10498 11.5953 2.10498Z" 
            fill={color}
            fillOpacity={opacity}
        />
    </svg>
  )
}
